import React from 'react';
import { Link } from 'react-router-dom';
import { useContact } from './ContactContext';

type Props = {
  to: string;
  text: string;
};

const LinkButton: React.FC<Props> = ({ to, text }) => {
  const { openContact } = useContact();

  const handleClick = (e: React.MouseEvent) => {
    if (to.startsWith('/contact')) {
      e.preventDefault();
      // Extract planName if it exists, e.g. /contact/プラチナプラン -> プラチナプラン
      const planName = to.replace('/contact', '').replace(/^\//, '');
      openContact(planName ? decodeURIComponent(planName) : '');
    }
  };

  return (
    <Link 
      to={to} 
      onClick={handleClick}
      style={{
        display: 'inline-block',
        padding: '15px 40px',
        background: '#6e1e50',
        color: '#fff',
        textDecoration: 'none',
        borderRadius: '50px',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        boxShadow: '0 5px 15px rgba(110,30,80,0.3)',
        transition: '0.3s',
        textAlign: 'center',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 20px rgba(110,30,80,0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 5px 15px rgba(110,30,80,0.3)';
      }}
    >
      {text}
    </Link>
  );
};

export default LinkButton;
